import { createStore } from 'jotai'

import { createRequestScopedStorage } from '@/utils/server'

const storeStorage = createRequestScopedStorage(() => createStore())

export const getStore = (): ReturnType<typeof createStore> =>
	storeStorage.getInstance()
